import React from 'react';

const cx = (...c) => c.filter(Boolean).join(' ');

const Container = ({ children, className, as: Tag = 'div' }) => (
  <Tag className={cx('mx-auto w-full max-w-container px-5 lg:px-8', className)}>{children}</Tag>
);

export default Container;
